import { call, put, takeLatest } from 'redux-saga/effects';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { PAYMENT_USING_GIFTCARD, PAYMENT_USING_GIFTCARD_SUCCESS, PAYMENT_USING_GIFTCARD_FAILURE, GIFTCARD_PURCHASE_STATUS, GIFTCARD_PURCHASE_STATUS_SUCCESS, GIFTCARD_PURCHASE_STATUS_FAIL, } from '../constants';
import { setErrorCode } from '../redux/Actions/ErrorAction';
export function* paymentUsingGiftCardCall(request) {
    try {
        const { payload } = request;
        const { customerId, tenantId, body } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': true,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.paymentUsingGiftCard, null, headers, body);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: PAYMENT_USING_GIFTCARD_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: PAYMENT_USING_GIFTCARD_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: PAYMENT_USING_GIFTCARD_FAILURE,
        });
    }
}
export function* paymentUsingGiftCardSaga() {
    yield takeLatest(PAYMENT_USING_GIFTCARD, paymentUsingGiftCardCall);
}
export function* purchaseGiftCardStatus(reqPayload) {
    try {
        const { payload } = reqPayload;
        const { tenantId = '', orderId = '' } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            'Content-Type': 'application/json',
        };
        const response = yield call(invokeApi, networkConfig.giftCardPurchaseStatus, {
            queryProps: {
                OrderId: orderId,
            },
        }, headers);
        if (response) {
            yield put({
                type: GIFTCARD_PURCHASE_STATUS_SUCCESS,
                response: response?.response,
            });
        }
        else {
            yield put({
                type: GIFTCARD_PURCHASE_STATUS_FAIL,
            });
        }
    }
    catch (error) {
        yield put({
            type: GIFTCARD_PURCHASE_STATUS_FAIL,
        });
    }
}
export function* giftCardStatus() {
    yield takeLatest(GIFTCARD_PURCHASE_STATUS, purchaseGiftCardStatus);
}
